export const scenes = [
  {
    id: 'live-slip-01',
    title: '直播翻车名场面：一句话让整屏弹幕笑到打鸣',
    category: 'iconic-scene',
    categoryName: '名场面',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20pop%20art%20illustration%20of%20a%20shattered%20microphone%20bursting%20into%20colorful%20comic%20shapes%20and%20speech%20bubbles%2C%20warm%20coral%20orange%20and%20amber%20gold%20palette%20on%20a%20simple%20cream%20background%2C%20bold%20flat%20graphic%20design%2C%20playful%20energetic%20mood%2C%20no%20people%2C%20no%20text&width=800&height=560&seq=tangxin-scene-01&orientation=landscape',
    excerpt:
      '本来只是一场平平无奇的深夜直播，结果主播顺口一句口误，弹幕瞬间从零星几条变成密密麻麻一片，全场节奏彻底失控。',
    heat: 128400,
    comments: 3620,
    danmaku: 18400,
    tags: ['直播名场面', '口误', '弹幕刷屏'],
    author: '吃瓜速递组',
    date: '2026-09-08',
    readTime: '4 分钟阅读',
    content: [
      '这场直播原本只是常规的深夜闲聊环节，观众数量稳定在几千人，偶尔飘过几条弹幕。主播聊到一半突然想介绍一下桌上的新道具，结果把名称说错了两个字，语气还格外自信。',
      '就是这两个字，让弹幕区安静了大概两秒钟。紧接着第一条玩梗式弹幕飘过，后面的人像接到信号一样开始疯狂接梗，短短十几秒屏幕就被同一句话填满。有观众后来统计，那一段的弹幕密度是平时峰值的六倍。',
      '主播一开始还没反应过来，认真解释了两遍自己的原意，结果越解释弹幕越欢乐。最后他干脆放弃挣扎，把口令当成节目环节玩了下去，反倒成了整场直播播放量最高的一段。',
      '事情最有意思的地方在于：真正被反复回放的并不是那个口误本身，而是网友们接梗的速度和创意。有人把它做成字幕截图，有人配上了新的场景台词，三天之内衍生出了好几个版本。',
    ],
    highlights: [
      { label: '原声现场', text: '“我说的是这个啊，你们别乱接……”' },
      { label: '弹幕第一条', text: '“好的，以后就这么叫了。”' },
      { label: '全场高能', text: '“他自己也笑了，节奏彻底不是他的了。”' },
    ],
    hotComments: [
      {
        user: '咸鱼不翻身',
        text: '最绝的是主播解释的那两遍，越解释越像在给自己挖坑，笑点直接翻倍。',
        likes: 8620,
        badge: '热评第一',
      },
      {
        user: '快乐星球住户',
        text: '我本来只是路过点进来的，结果把这一段循环了七遍，弹幕比内容好看系列。',
        likes: 5140,
      },
      {
        user: '键盘侠退散',
        text: '网友接梗的速度真的可怕，两秒钟就能统一口径，这届网友太有才了。',
        likes: 3270,
      },
    ],
  },
  {
    id: 'variety-catch-meme-02',
    title: '综艺接梗天花板：主持人当场破防，嘉宾一句话全场起立',
    category: 'meme-reply',
    categoryName: '接梗合集',
    cover:
      'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20retro%20television%20screen%20erupting%20with%20colorful%20speech%20bubbles%20and%20star%20shapes%2C%20warm%20orange%20amber%20palette%20on%20a%20clean%20cream%20background%2C%20bold%20graphic%20poster%20style%2C%20cheerful%20lively%20mood%2C%20no%20people%2C%20no%20text&width=800&height=560&seq=tangxin-scene-02&orientation=landscape',
    excerpt:
      '一段原本严肃的问答环节，因为嘉宾的一句接梗彻底跑偏。主持人笑着笑着就说不出下一句，这段被剪成短视频后迅速刷屏。',
    heat: 96400,
    comments: 2480,
    danmaku: 11200,
    tags: ['接梗合集', '综艺', '破防'],
    author: '热评观察室',
    date: '2026-09-06',
    readTime: '3 分钟阅读',
    content: [
      '这档综艺的问答环节一直以节奏舒缓著称，主持人习惯给嘉宾留足思考时间。当天的问题本身很常规，问的是“最近有没有遇到什么意外的事”。',
      '嘉宾先是很认真地讲了一段经历，讲到关键处忽然冒出一句非常妙的接梗，把整件事的荒诞感一下点破。主持人当场没绷住，镜头里明显能看到他低头笑了好几秒。',
      '现场观众的掌声还没停，弹幕区已经开始了第二轮创作。有网友把嘉宾那句话抽离出来，配上了完全不同的场景，竟然也毫无违和感，于是“万物皆可接这句”的玩法就传开了。',
      '这类接梗之所以能火，是因为它足够短、足够准，谁都能在生活里找到对应的场合。受众不是在围观一段节目，而是在借这句话说出自己想说的东西。',
    ],
    highlights: [
      { label: '嘉宾原话', text: '“我当时第一反应是——这剧本我没拿到啊。”' },
      { label: '主持人反应', text: '低头沉默三秒，然后说：“我们进下一题。”' },
      { label: '网友二创', text: '“开会、聚餐、相亲，这句话都能用上。”' },
    ],
    hotComments: [
      {
        user: '嗑瓜子专业户',
        text: '主持人那三秒的沉默比任何剧本都好看，真实反应永远最戳人。',
        likes: 6890,
        badge: '高能时刻',
      },
      {
        user: '不吃香菜',
        text: '这句话我已经在五个完全不同的场合用过了，每次都能破冰，太实用。',
        likes: 4020,
      },
    ],
  },
  {
    id: 'group-emoji-war-03',
    title: '群聊高能：一个表情包引发的刷屏大战，全员沦为复读机',
    category: 'group-chat',
    categoryName: '群聊高能',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20flat%20illustration%20collage%20of%20exploding%20chat%20bubbles%20and%20emoji%20faces%20flying%20outward%2C%20warm%20coral%20gold%20and%20jade%20green%20palette%20on%20a%20simple%20cream%20background%2C%20bold%20modern%20graphic%20style%2C%20fun%20social%20mood%2C%20no%20people%2C%20no%20text&width=800&height=560&seq=tangxin-scene-03&orientation=landscape',
    excerpt:
      '一个平平无奇的群，因为有人随手发了一张自制表情包，接下来两个小时所有人都停不下来，最后连管理员都忍不住加入复读。',
    heat: 74200,
    comments: 1860,
    danmaku: 6400,
    tags: ['群聊高能', '表情包', '复读机'],
    author: '群聊观察站',
    date: '2026-09-05',
    readTime: '3 分钟阅读',
    content: [
      '事情的起点非常朴素：有位群友加班到深夜，随手把自己疲惫的状态做成了一张表情包发进群里。配文只有四个字，却精准命中了所有人的当下心境。',
      '接下来的走向就很经典了。先是有三四个人跟着发同一张图，然后有人开始给这张图加工，加上不同的文字，再后来整个群变成了表情包创作大赛现场。',
      '最有趣的是管理员的反应。他一开始还试图维持秩序，提醒大家“别刷屏了”，结果看到某张新图之后自己也发了一张一模一样的，群里的欢乐值直接拉满。',
      '这类群聊片段之所以让人爱看，是因为它复刻了每个人都经历过的时刻——一群人为了同一个无聊的笑点聚在一起，什么都不用说，一张图就够了。',
    ],
    highlights: [
      { label: '事件起点', text: '“今天也是不想动的一天。”' },
      { label: '管理员名言', text: '“别刷了……这张图发我一份。”' },
      { label: '群聊高潮', text: '十几个人同时发出同一个表情包。' },
    ],
    hotComments: [
      {
        user: '深夜不睡星人',
        text: '“别刷了”后面接“发我一份”，这转折太真实了，管理员也没能逃过。',
        likes: 5930,
        badge: '神评论',
      },
      {
        user: '群聊潜水员',
        text: '我们群上周也是这样，最后大家把头像全换成同一张图，整整一天没恢复。',
        likes: 3110,
      },
    ],
  },
  {
    id: 'danmaku-overrun-04',
    title: '弹幕被彻底玩坏：这波操作之后，评论区集体失语',
    category: 'danmaku',
    categoryName: '弹幕玩梗',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20graphic%20art%20of%20crossing%20neon%20light%20bars%20and%20scattered%20glowing%20dots%20resembling%20streaming%20text%2C%20amber%20gold%20coral%20and%20jade%20green%20palette%20on%20a%20deep%20warm%20brown%20background%2C%20high%20contrast%20dynamic%20motion%20blur%2C%20digital%20poster%20style%2C%20no%20people%2C%20no%20readable%20text&width=800&height=560&seq=tangxin-scene-04&orientation=landscape',
    excerpt:
      '画面本身没什么特别，但弹幕用一句话把它变成了梗。等到视频播完，弹幕区的创作量已经超过了内容本身。',
    heat: 88900,
    comments: 2140,
    danmaku: 22600,
    tags: ['弹幕玩梗', '刷屏', '名句'],
    author: '弹幕研究所',
    date: '2026-09-03',
    readTime: '4 分钟阅读',
    content: [
      '这段视频的开头其实相当普通：一个日常场景，镜头缓慢推进，配乐也很轻。前三十秒里弹幕寥寥，偶尔有人路过打个招呼。',
      '转折发生在第四十秒左右。画面里一个不起眼的细节被某位观众捕捉到，随即发出一条简短的弹幕。这条弹幕恰好说出了所有人的共同感受，于是复制、改写、加长版接踵而至。',
      '到视频结尾时，整个屏幕已经被同一种句式覆盖，只是每一句的细节都不一样。有人把它当成了许愿池，有人当成了树洞，还有人认真地对着弹幕说起了心事。',
      '这种弹幕文化最特别的地方在于，它没有作者，也没有中心。每个人只贡献一句话，合起来却成为一个可以在几天内持续生长的集体创作。',
    ],
    highlights: [
      { label: '引爆弹幕', text: '“等一下，你们看到那个角落了吗？”' },
      { label: '弹幕名句', text: '“同一个世界，同一种生活。”' },
      { label: '结尾盛况', text: '满屏同一句式，细节各不相同。' },
    ],
    hotComments: [
      {
        user: '弹幕老人',
        text: '这种弹幕最珍贵的是一起完成一件事的感觉，看完会有点莫名的感动。',
        likes: 4720,
        badge: '深度共鸣',
      },
      {
        user: '随手一评',
        text: '我去看的时候已经刷到第三千条了，硬是没找到重样的，网友太有才。',
        likes: 2680,
      },
    ],
  },
  {
    id: 'top-comment-show-05',
    title: '热评第一永远在整活：评论区比正文精彩一百倍',
    category: 'hot-comment',
    categoryName: '热评现场',
    cover:
      'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20golden%20trophy%20built%20from%20stacked%20speech%20bubbles%20on%20a%20pedestal%2C%20warm%20coral%20orange%20and%20amber%20palette%20on%20a%20clean%20cream%20background%2C%20bold%20minimal%20graphic%20design%2C%20celebratory%20playful%20mood%2C%20no%20people%2C%20no%20text&width=800&height=560&seq=tangxin-scene-05&orientation=landscape',
    excerpt:
      '一条内容本身只有三行字，底下的热评却写出了三千字。当大家点进去只想看评论的时候，这件事本身就成了名场面。',
    heat: 61500,
    comments: 4180,
    danmaku: 3200,
    tags: ['热评现场', '评论区', '神回复'],
    author: '热评观察室',
    date: '2026-09-01',
    readTime: '3 分钟阅读',
    content: [
      '内容本身很短，讲了一件生活里常见的小事，语气平铺直叙没有任何修饰。按常理，这类内容的评论区应该也不会太热闹。',
      '但热评第一突然从完全不同的角度切入，把这件事重新讲了一遍，逻辑通顺、节奏极好，读起来比原文有意思得多。点赞数在几小时内就超过了内容本身。',
      '更妙的是第二条和第三条热评，它们不是简单地重复，而是接着第一条往下写，形成了一个层层递进的“评论连续剧”。有人专门截图保存了完整版。',
      '当评论区开始产出比正文更好的内容，围观者的动机就变了——大家是奔着评论来的。这也解释了为什么很多人的习惯是先看热评再看正文。',
    ],
    highlights: [
      { label: '热评第一', text: '“我换个角度说，这事其实是这样的……”' },
      { label: '网友补充', text: '“建议直接改成评论区连载。”' },
      { label: '围观共识', text: '正文三行字，评论三千字。' },
    ],
    hotComments: [
      {
        user: '评论区常驻',
        text: '我承认我是来看评论的，正文划了两秒就到底了，评论看了十分钟。',
        likes: 7210,
        badge: '说到心坎',
      },
      {
        user: '文学素养在逃',
        text: '热评第一那个结构真的很讲究，起承转合一个不少，比很多长文都好看。',
        likes: 3540,
      },
    ],
  },
  {
    id: 'meme-chain-06',
    title: '玩梗现场：全网都在接这一句，接得好真的会出圈',
    category: 'meme-reply',
    categoryName: '接梗合集',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20flat%20pop%20art%20of%20a%20domino%20chain%20made%20of%20colorful%20speech%20bubbles%20falling%20in%20sequence%2C%20warm%20coral%20amber%20and%20jade%20palette%20on%20a%20simple%20cream%20background%2C%20bold%20graphic%20illustration%2C%20dynamic%20connected%20feeling%2C%20no%20people%2C%20no%20text&width=800&height=560&seq=tangxin-scene-06&orientation=landscape',
    excerpt:
      '一句话火了之后，最精彩的永远不是原句，而是后面千万种接法。有人接得生硬，有人接得巧妙，差距一目了然。',
    heat: 55300,
    comments: 1620,
    danmaku: 4800,
    tags: ['接梗合集', '出圈', '二创'],
    author: '吃瓜速递组',
    date: '2026-08-30',
    readTime: '3 分钟阅读',
    content: [
      '一句有梗的话开始流传之后，通常会经历三个阶段：先是被原样复读，然后被改写到不同场景，最后被玩成一种句式模板。',
      '最能接梗的人，往往不是话最多的人，而是最懂“留白”的人。他们把原句的关键部分留下，其余全部替换成新场景的细节，听的人一下就懂。',
      '反过来，接得生硬的例子也不少。最常见的问题是把原句整段搬过来，场景却完全对不上，结果就是既不好笑也不自然，评论区会礼貌地保持沉默。',
      '所以接梗这件事，本质上考验的是对语境的理解。同一个梗，在不同人手里，出圈的概率差别可以非常大，这也是它最好看的地方。',
    ],
    highlights: [
      { label: '经典接法', text: '“同样的句式，换个场景，效果翻倍。”' },
      { label: '翻车现场', text: '“这句好像……有点不对味？”' },
      { label: '高手段位', text: '只改三个字，全场都懂了。' },
    ],
    hotComments: [
      {
        user: '梗学研究员',
        text: '接梗关键是真的懂原梗的笑点在哪，硬套是真的会翻车，见过太多了。',
        likes: 4380,
        badge: '专业解读',
      },
      {
        user: '路过看看',
        text: '最喜欢那种只改三个字的接法，看似轻描淡写，其实特别见功力。',
        likes: 2280,
      },
    ],
  },
  {
    id: 'scene-review-07',
    title: '名场面复盘：从一小段玩梗到全网出圈，只用了三天',
    category: 'iconic-scene',
    categoryName: '名场面',
    cover:
      'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20magnifying%20glass%20resting%20over%20colorful%20comic%20burst%20shapes%20and%20arrows%2C%20warm%20coral%20gold%20palette%20on%20a%20clean%20cream%20background%2C%20bold%20minimal%20graphic%20design%2C%20analytical%20yet%20fun%20mood%2C%20no%20people%2C%20no%20text&width=800&height=560&seq=tangxin-scene-07&orientation=landscape',
    excerpt:
      '一个名场面的诞生通常有迹可循：第一天小范围传播，第二天被集中二创，第三天彻底变成所有人都能用的句式。',
    heat: 49800,
    comments: 1240,
    danmaku: 3900,
    tags: ['名场面', '出圈复盘', '传播'],
    author: '名场面档案馆',
    date: '2026-08-27',
    readTime: '5 分钟阅读',
    content: [
      '第一天，内容只在一个很小的圈子里流传。看过的人不多，但几乎每个看过的人都会顺手转给朋友，因为它的笑点足够直接、不需要解释。',
      '第二天是关键的转折。一批创作者开始围绕它进行二次加工，做出了字幕版、配乐版、场景替换版。这一阶段决定了它能不能突破原有的圈子。',
      '第三天，它变成了一种句式。人们不再引用原片段，而是直接使用这套表达方式来描述自己的生活。到了这一步，它就已经不完全属于原出处了。',
      '回过头看，这类名场面的共同点是：门槛低、可复用、有情绪。三者缺一，流传范围都会明显受限。这也是观察网络玩梗文化时一个挺有意思的角度。',
    ],
    highlights: [
      { label: '第一天', text: '小圈子内流传，靠朋友互相转发。' },
      { label: '第二天', text: '二创集中爆发，各类版本涌现。' },
      { label: '第三天', text: '句式化完成，正式出圈。' },
    ],
    hotComments: [
      {
        user: '传播学爱好者',
        text: '“门槛低、可复用、有情绪”总结得很准，很多梗火不起来基本都缺一项。',
        likes: 3860,
        badge: '深度好文',
      },
      {
        user: '每天刷梗',
        text: '原来我们每次顺手转发的动作，都是出圈链条里的一环，有点神奇。',
        likes: 1940,
      },
    ],
  },
  {
    id: 'social-death-08',
    title: '社死瞬间名场面：当事人还在努力解释，网友已经在造梗了',
    category: 'hot-comment',
    categoryName: '热评现场',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20flat%20illustration%20of%20many%20small%20glowing%20smartphone%20screens%20crowded%20together%20with%20popcorn%20and%20spark%20shapes%2C%20warm%20coral%20amber%20palette%20on%20a%20clean%20cream%20background%2C%20bold%20graphic%20poster%20style%2C%20lively%20buzz%20mood%2C%20no%20people%2C%20no%20readable%20text&width=800&height=560&seq=tangxin-scene-08&orientation=landscape',
    excerpt:
      '一次普通的公开场合小失误，被现场的人记录下来。当事人花了一整天解释，网友花了半天就把梗造好了，速度差得有点好笑。',
    heat: 43200,
    comments: 1080,
    danmaku: 2700,
    tags: ['社死', '玩梗', '神评'],
    author: '热评观察室',
    date: '2026-08-24',
    readTime: '3 分钟阅读',
    content: [
      '事情的经过并不复杂：在一场公开活动上，当事人因为紧张说错了一句话，现场安静了两秒，随后被善意地笑了过去。',
      '如果事情到此为止，大概就是一次普通的小插曲。但现场有人把这段录了下来，当晚发到了自己的社交账号，配文只有一句调侃。',
      '第二天早上，当事人还在评论区认真解释自己的本意，而网友们已经开始用那句话造句了。有人做成表情包，有人写成了段子，甚至有人给它配了主题曲。',
      '最有意思的是当事人的后续回应：他先是有点无奈，后来看到大家的创作也确实好笑，干脆自己转发了一张表情包。围观也就在这种善意里慢慢散了。',
    ],
    highlights: [
      { label: '现场瞬间', text: '安静的两秒钟，比任何吐槽都有力。' },
      { label: '当事人解释', text: '“我当时的本意其实是……”' },
      { label: '网友反应', text: '“别解释了，梗已经造好了。”' },
    ],
    hotComments: [
      {
        user: '吃瓜第一线',
        text: '当事人那个解释的长文我看了，写得特别真诚，可惜评论区在忙着玩梗。',
        likes: 3210,
        badge: '热评第一',
      },
      {
        user: '温柔一点',
        text: '最后他自己转发表情包这段真的加分，能接住玩笑的人通常都挺可爱的。',
        likes: 2760,
      },
    ],
  },
];

export const getSceneById = (id: string) => scenes.find((item) => item.id === id);

export const getScenesByCategory = (slug: string) =>
  scenes.filter((item) => item.category === slug);